import React, { useState } from "react";
import { Questionnaire, QuestionnaireDefinition } from "../common/models";
import { QuestionnaireTaskView } from "../common/QuestionnaireTaskView";


const Definition: QuestionnaireDefinition = {
  name: 'Dyspnea Index (DI)',
  key: 'dyspneaIndexQuestionnaire',
  title: 'Dyspnea Index (DI)',
  cohort: 'respiratory',
  description: '',
  type: 'questionnaire',
  estimatedCompletionTime: '1:00',
  groups: [
    {
      key: 'dyspneaIndex',
      description: 'Please answer the following questions', 
      questions: [
        {
          key: 'airIn',
          type: 'multiple-choice',
          question: 'I have trouble getting air in.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'tightnessThroat',
          type: 'multiple-choice',
          question: 'I feel tightness in my throat when I am having my breathing problem.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'effortBreathe',
          type: 'multiple-choice',
          question: 'It takes more effort to breathe than it used to.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'weatherChanges',
          type: 'multiple-choice',
          question: 'Changes in the weather affect my breathing problem.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'breathingWorseStress',
          type: 'multiple-choice',
          question: 'My breathing gets worse with stress.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'soundBreathingIn',
          type: 'multiple-choice',
          question: 'I make sound/noise breathing in.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'strain',
          type: 'multiple-choice',
          question: 'I have to strain to breathe.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'exercise',
          type: 'multiple-choice',
          question: 'My shortness of breath gets worse with exercise or physical activity.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'breathingStressesMe',
          type: 'multiple-choice',
          question: 'My breathing problem makes me feel stressed.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'restrictPersonalSocialLife',
          type: 'multiple-choice',
          question: 'My breathing problem causes me to restrict my personal and social life.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
      ]
    }
  ]
};
export const DyspneaIndexDefinition = Definition;

export const DyspneaIndex = ({onCompletion}: {onCompletion: () => void}) => {
  const [questionnaire, setQuestionnaire] = useState<Questionnaire>(() => ({
    id: 'dyspneaIndexQuestionnaires',
    ...Definition,
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'in-progress',
  }));

  console.log('DyspneaIndex component rendered', questionnaire);

  const handleOnCompletion = () => {
    console.log('DyspneaIndex completed');

    onCompletion();
  };

  const handleOnChange = (questionnaire: Questionnaire) => {
    console.log('questionnaire', questionnaire);
    setQuestionnaire(questionnaire);
  }

  console.log('DyspneaIndex component rendered', questionnaire);

  return (
    <div>
      <QuestionnaireTaskView questionnaire={questionnaire} onChange={handleOnChange} onCompletion={handleOnCompletion  } />
    </div>
  );
}
